import React from "react";

const ConversionsListView = React.lazy(() => import("./ConversionsList.view"));

const ConversionsListLoadable = () => <ConversionsListView />;

export default () => <ConversionsListLoadable />;
